const WordLists = {
    adjForPeople: {
        id: 'adjForPeople',
        listName: 'Adjectives for People',
        listContents: [
            'angry',
            'beautiful',
            'clever',
            'crazy',
            'cute',
            'friendly',
            'funny',
            'happy',
            'old',
            'poor',
            'popular',
            'rich',
            'sad',
            'thin',
            'ugly',
            'young'
        ]
    },
    animals: {
        id: 'animals',
        listName: 'Animals',
        listContents: [
            'Bear',
            'Camel',
            'Crocodile',
            'Elephant',
            'Giraffe',
            'Gorilla',
            'Hippopotamus',
            'Kangaroo',
            'Koala',
            'Lion',
            'Monkey',
            'Panda',
            'Snake',
            'Tiger',
            'Wolf',
            'Zebra'
        ]
    },
    body: {
        id: 'body',
        listName: 'Body',
        listContents: [
            'back',
            'chest',
            'feet',
            'finger',
            'foot',
            'hand',
            'head',
            'hip',
            'knee',
            'leg',
            'neck',
            'shoulder',
            'teeth',
            'throat',
            'toes',
            'waist'
        ]
    },
    clothes: {
        id: 'clothes',
        listName: "Clothes",
        listContents: [
            'belt',
            'coat',
            'dress',
            'gloves',
            'hat',
            'jacket',
            'jeans',
            'scarf',
            'shirt',
            'shoes',
            'skirt',
            'socks',
            'suit',
            't-shirt',
            'tie',
            'trousers'
        ]
    },
    countries: {
        id: 'countries',
        listName: 'Countries',
        listContents: [
            'America',
            'Australia',
            'Brazil',
            'Canada',
            'China',
            'England',
            'France',
            'Germany',
            'India',
            'Ireland',
            'Italy',
            'Japan',
            'New Zealand',
            'Russia',
            'Scotland',
            'Spain'
        ]
    },
    fruit: {
        id: 'fruit',
        listName: 'Fruit',
        listContents: [
            'apple',
            'avacado',
            'banana',
            'blackberry',
            'blueberry',
            'cherry',
            'grapes',
            'kiwi',
            'lemon',
            'lime',
            'mango',
            'peach',
            'pear',
            'pineapple',
            'strawberry',
            'watermelon',
        ]
    },
    head: {
        id: 'head',
        listName: 'Head',
        listContents: [
            'beard',
            'cheek',
            'chin',
            'ear',
            'eyebrow',
            'eyelash',
            'eye',
            'forehead',
            'hair',
            'lips',
            'mouth',
            'nose',
            'nostril',
            'teeth',
            'tongue',
            'tooth'
        ]
    },
    sports: {
        id: 'sports',
        listName: 'Sports',
        listContents: [
            'archery',
            'badminton',
            'basketball',
            'boxing',
            'football',
            'golf',
            'gymnastics',
            'hockey',
            'hurling',
            'karate',
            'rugby',
            'soccer',
            'swimming',
            'table tennis',
            'tennis',
            'volleyball'
        ]
    },
    custom: {
        id: 'custom',
        listName: 'Custom',
        listContents: []
    }
}

export default WordLists;